import type {
  DocumentSort, IDocument, IDocumentFolder, NaviData,
} from '../../types';
import { createSliceSteamup } from '../common';

export interface IDocumentState {
  loading: boolean;
  root: IDocumentFolder;
  currentFolderUUID: string;
  sort: DocumentSort;

  isPurchased: boolean;
  isEditable: boolean;
  purchaseConfirm: boolean;

  expandedFolders: IDocumentFolder[];
  selectedFiles: IDocument[];
  focusedFile: IDocument | null;
  nameEditTarget: IDocument | null;

  moveTargetCurrentFolder: IDocumentFolder | null;
  moveTargetDocuments: IDocument[];

  naviData: NaviData[];
  keyboard: {
    ctrl: boolean,
    shift: boolean,
  }

  searchString: string;
  // 새로 추가
  contentsType: string;
  countData: number;
  isSearch: boolean;
}

const root: IDocumentFolder = {
  type: 'folder',
  uuid: '',
  name: '내 콘텐츠',
  createdAt: new Date(),
  children: [],
};

const documentSlice = createSliceSteamup(
  'document',
  {
    loading: true,
    root,
    sort: {
      type: 'name',
      direction: 'ASC',
    },

    isPurchased: false,
    isEditable: false,
    purchaseConfirm: false,

    currentFolderUUID: '',
    expandedFolders: [root],
    selectedFiles: [],
    focusedFile: null,
    nameEditTarget: null,

    moveTargetCurrentFolder: null,
    moveTargetDocuments: [],

    naviData: [],
    keyboard: {
      ctrl: false,
      shift: false,
    },

    searchString: '',
    contentsType: 'myContents',
    // 클래스 모달 위해 추가중
    classesType: 'myClasses',
    countData: 0,
    isSearch: false,
  } as IDocumentState,
);

export default documentSlice;
